// 下发数据组装相关的纯函数工具
// 这些函数不依赖任何响应式状态，输入数据 -> 输出数据，可安全复用

import { solveCubicCoefficients } from './cubicCurve.js'

function roundNum(num, digits = 6) {
  return Number(num.toFixed(digits))
}

// 把单个舵机的 motion 列表转成下发用的三次曲线系数载荷
// angleScale：轨迹舵机的角度需要按 0.4882 换算，普通舵机为 1（不换算）
function buildMotionParams(motions, angleScale = 1) {
  return motions
    .filter(motion => motion && motion.steps !== undefined)
    .map(motion => {
      const steps = motion.steps
      const start = motion.param[0] / angleScale
      const end = motion.param[1] / angleScale
      const y1 = motion.param[2] / angleScale
      const y2 = motion.param[3] / angleScale

      const x0 = 0, y0 = start
      const x1 = steps / 3, x2 = 2 * steps / 3
      const x3 = steps, y3 = end
      const coeffs = solveCubicCoefficients(x0, y0, x1, y1, x2, y2, x3, y3)
      // [start, end, k3, k2, k1, k0]，k3~k0 保留 6 位小数
      return {
        steps,
        param: [...coeffs.map(x => roundNum(x))]
      }
    })
}

// 由普通舵机和轨迹舵机组装下发数据（纯函数）
// servos：普通舵机数组；trajectoryConfigs：轨迹配置数组
export function buildServoSendData(servos, trajectoryConfigs) {
  const normalServoData = (servos || []).map(servo => ({
    s: servo.s,
    c: servo.m.length,
    l: servo.l,
    m: buildMotionParams(servo.m, 1)
  }))

  const trajectoryServoData = []
  ;(trajectoryConfigs || []).forEach(trajectory => {
    if (trajectory.servos && trajectory.servos.length > 0) {
      trajectory.servos.forEach(servo => {
        trajectoryServoData.push({
          s: servo.s,
          c: servo.m.length,
          l: servo.l,
          m: buildMotionParams(servo.m, 0.4882)
        })
      })
    }
  })

  return [...normalServoData, ...trajectoryServoData]
}

// 由组合动作记录的 mcpData 组装"直接运行"用的下发载荷（纯函数）
export function buildComboSendPayload(mcpData, deviceId) {
  if (!mcpData || !mcpData.params || !mcpData.params.arguments) return null
  // 深拷贝避免污染原始数据
  const obj = JSON.parse(JSON.stringify(mcpData))
  obj.device_id = deviceId
  obj.params.arguments.operate = 1            // 1 = 直接运行（非保存到设备）
  obj.params.arguments.name = 'default_run'
  const motion = obj.params.arguments.motion
  obj.params.arguments.motion = typeof motion === 'string' ? motion : JSON.stringify(motion)
  return obj
}
